export default __webpack_public_path__ + "static/media/delete-inactive.67cfc4d3.svg";